import { memo } from "react";
import { type CenterValue, type GoogleMarker } from "~/domains/salesPartner/types/SalesPartnerTypes";
import CenterContents from "~/common/components/CenterContents";
import { useIsGoogleApiLoaded } from "~/features/salesPartner/providers/GoogleApiProvider";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { SPCompanyDetailsCard } from "~/features/salesPartner/components/CompanyDetailsCard/SPCompanyDetailsCard";
import { SPMap } from "~/features/salesPartner/components/MapSection/Map/SPMap";
import { MobileMapTile } from "~/features/salesPartner/components/MapSection/MobileMapTile";
import { IMG_MAP_BLOCKED } from "~/utils/url/staticResources";

interface Props {
  markers: GoogleMarker[];
  selectedMarker: GoogleMarker | undefined;
  center: CenterValue;
  zoomValue: number;
  setZoomValue: (newVal: number) => void;
  selectSalesPartner: (marker: GoogleMarker | undefined, canOpenPopup?: boolean) => void;
  shareLinearConfigurationData?: string[];
  openDetailsPopup: () => void;
  openRegisterSnackbar: () => void;
  isCheckout: boolean;
  activeTab: string;
  onClose?: () => void;
}

const SPMapSection = (props: Props) => {
  const {
    markers,
    selectedMarker,
    center,
    zoomValue,
    activeTab,
    setZoomValue,
    selectSalesPartner,
    openDetailsPopup,
    openRegisterSnackbar,
    onClose,
  } = props;

  const { isLoaded, isError } = useIsGoogleApiLoaded();
  const isDesktop = useIsMinDesktopSize();

  return (
    <div className="scha__sp__map">
      {isLoaded && (
        <SPMap
          className={isDesktop ? undefined : "fullbleed"}
          markers={markers}
          selectedMarker={selectedMarker}
          center={center}
          zoomValue={zoomValue}
          setZoomValue={setZoomValue}
          selectSalesPartner={selectSalesPartner}
        >
          {selectedMarker && isDesktop && (
            <SPCompanyDetailsCard
              onClose={onClose}
              selectedMarker={selectedMarker}
              activeTab={activeTab}
              shareLinearConfigurationData={props.shareLinearConfigurationData}
              openRegisterSnackbar={openRegisterSnackbar}
              isCheckout={props.isCheckout}
            />
          )}
          {selectedMarker && !isDesktop && (
            <MobileMapTile
              className={"scha__sp__mobile-selected-card"}
              marker={selectedMarker}
              openDetailsPopup={openDetailsPopup}
              onClose={() => selectSalesPartner(undefined)}
            />
          )}
        </SPMap>
      )}
      {isError && (!isDesktop || !selectedMarker) && (
        <CenterContents className={"w-100 flex-align-self-start mt-60"}>
          <img src={IMG_MAP_BLOCKED} />
        </CenterContents>
      )}
      {isError && selectedMarker && isDesktop && (
        <SPCompanyDetailsCard
          onClose={onClose}
          className={"m-0"}
          selectedMarker={selectedMarker}
          activeTab={activeTab}
          shareLinearConfigurationData={props.shareLinearConfigurationData}
          openRegisterSnackbar={openRegisterSnackbar}
          isCheckout={props.isCheckout}
        />
      )}
    </div>
  );
};

export default memo(SPMapSection);
